import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemUserGetSchema} from '../../../../api/DBSchema/SystemUser';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCButton from '../../../../components/Simple/SMCButton';
import ShowQRModal from '../../../PopupPages/ShowQRModal';
import {useBoolean} from '../../../../utils/hooks';
import {ObjectTypes} from '../../../../api/consts';

const pageSchema = SystemUserGetSchema.pages.twoStepAuth;
const pageId = pageSchema.pageId;

function SystemUserTwoStepAuth({
    origSystemUserObject,
    systemUserObject
}) {
    const { t } = useTranslation();

    const pageData = systemUserObject[pageId];
    const isTwoFactorAuth = pageData[pageSchema.isTwoFactorAuth];
    const twoFactorAuthQrUrl = pageData[pageSchema.twoFactorAuthQrUrl];
    
    // Take original user email, and not the current
    const userEmail = origSystemUserObject[SystemUserGetSchema.pages.general.pageId]?.[SystemUserGetSchema.pages.general.email];
    const userId = systemUserObject[SystemUserGetSchema.id];

    const [isQRCodeModalOpen, openQRCodeModal, closeQRCodeModal] = useBoolean(false);

    return (
        <EditorLayout>
            <RowLayout spacing="6px">
                <SMCLabel inline>{t('SMP.PAGE.2FA_ENABLE')}</SMCLabel>
                {/* isTwoFactorAuth - readonly */}
                <SMCCheckbox checked={isTwoFactorAuth} disabled /> 
                <SMCButton disabled={!isTwoFactorAuth} onClick={openQRCodeModal} ignoreDisabledContext>{t('SMP.USERS.TABLE.PAGES.2FA.SHOW_QR')}</SMCButton>
            </RowLayout>
            {/* Popup windows */}
            <ShowQRModal
                isOpen={isQRCodeModalOpen}
                onRequestClose={closeQRCodeModal}
                qrLink={twoFactorAuthQrUrl}
                userEmail={userEmail}
                objectType={ObjectTypes.SYSTEM_USER}
                userId={userId}
            />
        </EditorLayout>
    )
}

export default SystemUserTwoStepAuth;